import { FileType } from '../api-types';
import { Caption } from '../utility-types';

export interface ResourceCategoryType {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  skills: number;
  modules: number;
}

export interface ResourceFileType extends FileType {
  resourceId: string;
  captions: Caption[];
}

export interface ResourceDocType {
  id: string;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  type: ResourceTAB;
  gradeLevel: number;
  access: string[];
  files?: ResourceFileType;
  thumbnail?: ResourceFileType;
  isFav: boolean;
  video?: ResourceFileType;
  videoUrl?: string;
  cost?: number;
  isUnlocked?: boolean;
  unlockedResources?: {
    studentId: string;
    resourceId: string;
    price: number;
  }[];
}

export interface ResourceFilterSkillType {
  id: string;
  name: string;
}

export interface ResourceSkillType extends ResourceFilterSkillType {
  docs: ResourceDocType[];
}

export interface ResourceType {
  id: string;
  name: string;
  skills: ResourceSkillType[];
}

export interface ResourceFilterOptionType {
  skills: ResourceFilterSkillType[];
  gradeLevel: number[];
}

export enum ResourceTAB {
  NOTES = 'NOTES',
  ACTIVITIES = 'ACTIVITIES',
  CASE_STUDIES = 'CASE',
  LESSON = 'LESSON',
  VIDEOS = 'VIDEO',
  SLIDES = 'SLIDES',
}

export interface ResourceFilterQueryType {
  search?: string;
  gradeLevel?: number[];
  skills?: string[];
}
